import { type ApolloCache, InMemoryCache } from '@apollo/client';
import { type Workspace } from '@reconcept-platform/shared/types';

export const invalidateWorkspace =
  (workspaceId: string, invalidationKeys: (keyof Workspace)[] = []) =>
  (cache: ApolloCache): void => {
    if (!workspaceId) {
      console.error('No workspaceId to invalidate');
    }

    cache.modify({
      id: 'Workspace:' + workspaceId,
      fields(fieldValue, details) {
        if (invalidationKeys.find((key) => details.fieldName.startsWith(key))) {
          return details.DELETE;
        }

        return undefined;
      },
    });
  };

// for when the affected workspaces are unknown, e.g. a cascade that touches workspaces server-side
export const invalidateAllWorkspaces =
  (invalidationKeys: (keyof Workspace)[]) =>
  (cache: ApolloCache): void => {
    // the base ApolloCache types extract() as unknown; InMemoryCache exposes the normalized entries
    if (!(cache instanceof InMemoryCache)) {
      return;
    }

    Object.keys(cache.extract())
      .filter((cacheId) => cacheId.startsWith('Workspace:'))
      .forEach((cacheId) => {
        invalidationKeys.forEach((fieldName) => {
          cache.evict({ id: cacheId, fieldName });
        });
      });

    cache.gc();
  };
